import { Component } from '@angular/core';
import {  NavController, NavParams, ModalController, ActionSheetController, ViewController } from 'ionic-angular';
import { VaryantEkleGuncellePage } from '../varyant-ekle-guncelle/varyant-ekle-guncelle';
import { BllOrtak } from '../../../providers/bll/bll-ortak';
import { Ortak } from '../../../providers/ortak';
import { StokHareketleriPage } from '../stok-hareketleri/stok-hareketleri';
import { SayimGirisiPage } from '../sayim-girisi/sayim-girisi';

/**
 * Generated class for the VaryantlarPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

 
@Component({
  selector: 'page-varyantlar',
  templateUrl: 'varyantlar.html',
})
export class VaryantlarPage {
  aranan="";
  skip:number=0;
  take:number=100;
  varyantListesi=[];
  yaziciadi: any;
  StokKartID:number=-1;
  kullaniciyetki: any;
  param: any = { KullaniciSayimYapabilsinMi: "" };
  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public modalCtrl:ModalController,
    public act:ActionSheetController,
    public viewCtrl:ViewController,
     public navParams: NavParams) {
      this.yaziciadi = this.ortak.aktifYazici;
      this.kullaniciyetki = this.ortak.kullaniciType;

      if (navParams.get("varyant") != null) {
        this.StokKartID = navParams.get("varyant");
        console.log("gelStok",this.StokKartID )
        var data = new FormData();
        data.append("stok_id", this.StokKartID.toString());
        this.bllOrtak.islem(data, "VaryantGetirByBagliID", "", false).then(a => {
          var Sonuc = <any>a;
          this.varyantListesi = Sonuc.SonucObject;

         
        }
        )
  }}
  parametreleriGetir() {
    this.bllOrtak.islemWithoutPost("ParametreleriVer", "", false).then(a => {
      var sonuc = <any>a;
      this.param = sonuc.SonucObject;

    })
  }
KayitAra()
{  var data = new FormData();
  data.append("stok_id", this.StokKartID.toString());
  this.bllOrtak.islem(data, "VaryantGetirByBagliID", "", false).then(a => {
    var Sonuc = <any>a;
    this.varyantListesi = Sonuc.SonucObject;
});
}
  ionViewDidLoad() {
   this.KayitAra();
   this.parametreleriGetir();
  }
  
   
  yenikayit() {
    let modal = this.modalCtrl.create(VaryantEkleGuncellePage,{ bagliID: this.StokKartID });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    this.KayitAra();
    modal.present();

  }
  kayitduzenle(varyant){
    let modal = this.modalCtrl.create(VaryantEkleGuncellePage, { stok_id: varyant.ID });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    this.KayitAra();
    modal.present();
   
  }
  VaryantSil(varyant) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();

      formData.append("ID", varyant.ID);

      this.bllOrtak.islem(formData, "VaryantSil", "", true).then(a => {
        var sonuc = <any>a;
       if(sonuc.Sonuc==1)
       {
        this.ortak.showBasicAlert("Başarılı","Birim başarılı bir şekilde silinmiştir");
        this.KayitAra();
       }
 
       if(sonuc.Sonuc==0)this.ortak.showBasicAlert("Uyarı","Birim bir ürüne kayıtlı olduğu için silinemedi");
       if(sonuc.Sonuc==99)console.log(sonuc.SonucObject);
      }).catch(x => {

        this.ortak.showErrorAlert();
      })
     
    })
   
  }
  etiketgonder(Stok) {

    this.ortak.showConfirmAlert("Uyarı", "Etiket Basıma Gönderilecek. Devam etmek istiyor musunuz?").then(k => {

      var formData = new FormData();
      formData.append("stokid", Stok.ID.toString());
      formData.append("yaziciadi", this.yaziciadi);
      this.bllOrtak.etiketbas(formData, "RafEtiketiBasTekli", "", true).then(a => {
        var sonuc = <any>a;

        if (sonuc.Sonuc == 1) {
          this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
        }

        if (sonuc.Sonuc == 99) console.log("err", sonuc.SonucObject);
      }).catch(x => {
        console.log(x);
      })
    })
  }
  stokhareketleri(Stok) {
    let modal = this.modalCtrl.create(StokHareketleriPage, { stok: Stok });
    modal.present();
  }
  SayimGirisi(Stok) {
    if (this.kullaniciyetki == 2) {
      let modal = this.modalCtrl.create(SayimGirisiPage, { vwUrun: Stok });
      modal.onDidDismiss(data => {
        this.ionViewDidLoad();
      });
      modal.present();

    }

    else {
      if (this.param.KullaniciSayimYapabilsinMi == 1) {
        let modal = this.modalCtrl.create(SayimGirisiPage, { vwUrun: Stok });
        modal.onDidDismiss(data => {
          this.ionViewDidLoad();
        });
        modal.present();
      }
      else {
        this.ortak.showBasicAlert("Uyarı", "Bu işlemi yapmaya yetkiniz yok lütfen yöneticinize başvurunuz");
      }

    }

  }
  Islemler(vary) {
    const actionSheet = this.act.create({
      title: vary.StokAdi,
      buttons: [
        {
          text: 'Sil',

          handler: () => {
            this.VaryantSil(vary);
          }

        },
        {
          text: 'Stok Hareketleri',

          handler: () => {
            this.stokhareketleri(vary);
          }

        },
        {
          text: 'Sayım Girişi',

          handler: () => {
            this.SayimGirisi(vary);
          }

        },
        {
          text: 'Etiket Bas',
          handler: () => {
            this.etiketgonder(vary);
          }
        },
        {
          text: 'Düzenle',
          handler: () => {
            this.kayitduzenle(vary);
          }
        }, {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            
          }
        }
      ]
    });
    actionSheet.present();
  }   
  cikis()
  {
    this.viewCtrl.dismiss();
  }


}



// WEBPACK FOOTER //
// ./src/pages/StokIslemleri/varyantlar/varyantlar.ts